import React, { useCallback, useState } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import withApiError, {
  ERROR_TYPE_REPORTING,
} from 'layers/errorHandling/apiError'
import { selectors as reportsSelectors } from 'store/reportsManager'
import SchoolSummary from './component'
import {
  selectSchoolSummaryReportTableData,
  UNIT_RANGE_OPTIONS,
} from './selectors'

export const SchoolSummaryContainer = ({
  administratorsCount,
  classDetailsReport,
  gradesWithClasses,
  gradesWithNoClasses,
  entry,
  hasClassesWithCompletedLessonLastPeriod,
  isFetchingSchool,
  k8ReportUnitSection,
  lastUpdatedAt,
  navigationHandler,
  numClassesWithCompletedLessonLastPeriod,
  period,
  getReportTableData,
  schoolEmptyDisplay,
  selectedClassInstance,
  selectedSite,
  siteName,
  teachersCount,
  totalClassesCount,
}) => {
  const [selectedUnitRange, setSelectedUnitRange] = useState(
    UNIT_RANGE_OPTIONS.CORE,
  )

  const handleSelectGrade = (navigationFunction, gradeName) => {
    navigationFunction({
      gradeName,
      siteId: selectedSite,
    })
  }

  const handleUnitRangeChange = useCallback(unitRange => {
    setSelectedUnitRange(unitRange)
  }, [])

  const reportTableData = getReportTableData(selectedUnitRange)

  return (
    <SchoolSummary
      administratorsCount={administratorsCount}
      classDetailsReport={classDetailsReport}
      entry={entry}
      gradesWithClasses={gradesWithClasses}
      gradesWithNoClasses={gradesWithNoClasses}
      handleSelectGrade={handleSelectGrade}
      handleUnitRangeChange={handleUnitRangeChange}
      hasClassesWithCompletedLessonLastPeriod={
        hasClassesWithCompletedLessonLastPeriod
      }
      isFetchingSchool={isFetchingSchool}
      k8ReportUnitSection={k8ReportUnitSection}
      lastUpdatedAt={lastUpdatedAt}
      navigationHandler={navigationHandler}
      numClassesWithCompletedLessonLastPeriod={
        numClassesWithCompletedLessonLastPeriod
      }
      period={period}
      reportTableData={reportTableData}
      schoolEmptyDisplay={schoolEmptyDisplay}
      selectedClassInstance={selectedClassInstance}
      selectedSite={selectedSite}
      selectedUnitRange={selectedUnitRange}
      siteName={siteName}
      teachersCount={teachersCount}
      totalClassesCount={totalClassesCount}
    />
  )
}

export const mapStateToProps = state => {
  const { reportsManager, router } = state
  const { isFetchingSchool, selectedSite } = reportsManager || {}
  const getReportTableData = selectedUnitRange =>
    selectSchoolSummaryReportTableData(state, selectedUnitRange)
  const schoolSummaryReport = reportsSelectors.selectSchoolSummaryReport(state)
  const {
    administratorsCount,
    gradesWithClasses,
    gradesWithNoClasses,
    hasClassesWithCompletedLessonLastPeriod,
    lastUpdatedAt,
    numClassesWithCompletedLessonLastPeriod,
    period,
    siteName,
    teachersCount,
    totalClassesCount,
  } = schoolSummaryReport || {}

  const selectedClassInstance = router?.location?.query?.class || ''
  const classDetailsReport = reportsSelectors.selectClassDetailsReport(
    state,
    selectedClassInstance,
  )

  return {
    administratorsCount,
    classDetailsReport,
    getReportTableData,
    gradesWithClasses,
    gradesWithNoClasses,
    hasClassesWithCompletedLessonLastPeriod,
    isFetchingSchool,
    numClassesWithCompletedLessonLastPeriod,
    period,
    lastUpdatedAt,
    selectedClassInstance,
    selectedSite,
    siteName,
    teachersCount,
    totalClassesCount,
  }
}

SchoolSummaryContainer.propTypes = {
  administratorsCount: PropTypes.number,
  classDetailsReport: PropTypes.object,
  entry: PropTypes.object,
  getReportTableData: PropTypes.func,
  gradesWithClasses: PropTypes.array,
  gradesWithNoClasses: PropTypes.array,
  hasClassesWithCompletedLessonLastPeriod: PropTypes.bool,
  isFetchingSchool: PropTypes.bool,
  k8ReportUnitSection: PropTypes.string,
  lastUpdatedAt: PropTypes.string,
  navigationHandler: PropTypes.func,
  numClassesWithCompletedLessonLastPeriod: PropTypes.number,
  period: PropTypes.number,
  schoolEmptyDisplay: PropTypes.object,
  selectedClassInstance: PropTypes.string,
  selectedSite: PropTypes.number,
  siteName: PropTypes.string,
  summaryReportExists: PropTypes.bool,
  summaryReportIsFetching: PropTypes.bool,
  teachersCount: PropTypes.number,
  totalClassesCount: PropTypes.number,
}

export default connect(mapStateToProps)(
  withApiError(SchoolSummaryContainer, [ERROR_TYPE_REPORTING]),
)
